export const GERMAN = 'de-DE';
export const FRENCH = 'fr-FR';
export const ENGLISH = 'en-US';
export const SPANISH = 'es-ES';
